
<script>
	import deliverytool from '@/tool/deliverytool/index.vue'
	import listBase from '@_system/components/base/list.vue'
	import handleIndex from './lib/handle/index.vue'
	import configIndex from './lib/config/index.vue'
	export default {
		extends: listBase,
		props: {

		},
		render(h) {
			// this.$slots.mainheader = [
			// 	<el-tag type="danger" size="mini">付款后12~50小时快递异常订单</el-tag>
			// ]
			this.$slots.plug = [
				<handle-index ref="handleBox" title={this.handletitle} row={this.currentrow} onDeliverytool={this.deliverytoolShow} onSuccess={this.handleBoxSuccess} />,
				this.deliverytool?<deliverytool data={this.currentdata} action={this.currentaction} ref="deliverytool" onHide={this.deliverytoolHide} />:'',
				<config-index ref="configIndex" data={this.configdata} />,
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				configdata:{},
				moduleName: 'compensationnotice',
				windowName: '赔付预警',
				windowType: 'modal',
				defaultFormValue:[
					// {
					// 	field:"tp_status",
					// 	default:['4','3','2','1']
					// },
					{
						field:"tp_pay_duration",
						default:"大于0【并且】小于50"
					},
				],
				pagerConfig: {
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [20,100,500,1000,5000],
				},
				exportCustomColumn: [{
					title: '快递单号',
					label: 'invoicetemplate',
					field: [
						'salercpt_no',
						'delivery_name',
						'express_uid'
					]
				}],
				handletitle:'',
				currentrow:[],
				currentdata:[],
				currentaction:'',
				deliverytool:false
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			this.$refs[this.exportRef].exportCustomColumn = this.exportCustomColumn
		},
		computed: {

		},

		methods: {
			config(){
				this.$api.config.get(0,{module:'compensationnotice'}).then((res)=>{
					this.configdata = res
					this.$refs.configIndex.modal_show()
				})
			},
			handle(e){
				let data = []
				this.handletitle = '请选择处理方式'
				if(e){
					data = [e]
				}else{
					data = this.getGrid().getCheckboxRecords()
				}
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}
				this.currentrow = data
				this.$refs.handleBox.modalShow()
			},
			handleBoxSuccess(){
				this.customreload()
			},
			deliverytoolShow(e){
				if( e.data.length!=0){
					this.currentdata = e.data
					if(e.action==1){
						this.currentaction = "提前揽收"
					}
					if(e.action==2){
						this.currentaction = "催件"
					}				
					this.deliverytool = true
				}else{
					this.$message.error('未发现快递单号')
				}
			},
			deliverytoolHide(){
				this.currentdata = []
				this.currentaction = ''
				this.deliverytool = false
				this.customreload()
			}

		},
		components: {
			handleIndex,
			deliverytool,
			configIndex
		}
	}
</script>
